import * as React from 'react';
const Menu = ({
  width = 24,
  height = 24,
  ...props
}: {
  height?: number;
  width?: number;
  props?: any;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" {...props}>
    <g mask="url(#a)">
      <path
        fill="#171717"
        d="M4.25 17.635a.726.726 0 0 1-.534-.216.726.726 0 0 1-.216-.535c0-.212.072-.39.216-.534a.726.726 0 0 1 .534-.215h15.5c.212 0 .39.071.534.215a.726.726 0 0 1 .216.535c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.216H4.25Zm0-4.885a.726.726 0 0 1-.534-.216A.726.726 0 0 1 3.5 12c0-.213.072-.391.216-.535a.726.726 0 0 1 .534-.215h15.5c.212 0 .39.072.534.216A.726.726 0 0 1 20.5 12c0 .213-.072.391-.216.535a.726.726 0 0 1-.534.215H4.25Zm0-4.885a.725.725 0 0 1-.534-.215.726.726 0 0 1-.216-.535c0-.213.072-.39.216-.534a.726.726 0 0 1 .534-.216h15.5c.212 0 .39.072.534.216a.726.726 0 0 1 .216.535c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.215H4.25Z"
      />
    </g>
  </svg>
);
export default React.memo(Menu);
